export default "__VITE_ASSET__Cv0xjE5N__"